const HappyFaceEmoji = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="happy-face-emoji"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.57 22.84C44.34 20.66 42.02 19.31 39.52 19.31C37.02 19.31 34.7 20.66 33.47 22.84L35.21 23.83C36.09 22.28 37.74 21.31 39.53 21.31C41.32 21.31 42.96 22.28 43.84 23.83L45.58 22.84H45.57ZM26.53 22.84C25.3 20.66 22.98 19.31 20.48 19.31C17.98 19.31 15.66 20.66 14.43 22.84L16.17 23.83C17.05 22.28 18.7 21.31 20.48 21.31C22.26 21.31 23.91 22.28 24.79 23.83L26.53 22.84ZM30 45.72C22.43 45.72 15.94 40.32 14.56 32.89L14.34 31.71H45.67L45.45 32.89C44.07 40.32 37.57 45.72 30.01 45.72H30ZM30 55C16.21 55 5 43.79 5 30C5 16.21 16.21 5 30 5C43.79 5 55 16.22 55 30C55 43.78 43.78 55 30 55Z"
        fill="white"
      />
      <path
        d="M30 5C43.78 5 55 16.22 55 30C55 43.78 43.78 55 30 55C16.22 55 5 43.79 5 30C5 16.21 16.21 5 30 5ZM35.21 23.83C36.09 22.28 37.74 21.31 39.53 21.31C41.32 21.31 42.96 22.28 43.84 23.83L45.58 22.84C44.35 20.66 42.03 19.31 39.53 19.31C37.03 19.31 34.71 20.66 33.48 22.84L35.22 23.83M16.16 23.83C17.04 22.28 18.69 21.31 20.47 21.31C22.25 21.31 23.9 22.28 24.78 23.83L26.52 22.84C25.29 20.66 22.97 19.31 20.47 19.31C17.97 19.31 15.65 20.66 14.42 22.84L16.16 23.83ZM30 45.72C37.57 45.72 44.06 40.32 45.44 32.89L45.66 31.71H14.34L14.56 32.89C15.94 40.32 22.44 45.72 30 45.72ZM30 3C15.11 3 3 15.11 3 30C3 44.89 15.11 57 30 57C44.89 57 57 44.89 57 30C57 15.11 44.89 3 30 3Z"
        fill="#004628"
      />
    </svg>
  )
}

export default HappyFaceEmoji
